import React, { createContext, useState, useContext, useEffect } from 'react';
import { cmsApi } from '../Utils/API';
import { setupMaintenanceHandling } from '../Utils/API';
import { LANDING_PAGE_CMS_DATA } from '../Utils/GlobalConstants';

// Create the maintenance context
const MaintenanceContext = createContext();

// Create a custom hook to use the maintenance context
export const useMaintenanceContext = () => useContext(MaintenanceContext);

// Create the provider component
export const MaintenanceProvider = ({ children }) => {
  const [maintenanceActive, setMaintenanceActive] = useState(false);
  const [maintenancePageData, setMaintenancePageData] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Function to fetch maintenance data from CMS
  const fetchMaintenanceData = async () => {
    setIsLoading(true);
    const data = `{
      maintenancePage {
        content {
          html
        }
        maintenanceFlag
      }
    }`;

    // Defining Header Configuration
    const config = {
      headers: {
        "Content-Type": "application/graphql",
        Accept: "application/graphql",
      },
    };

    try {
      // Axios Post Request
      const resp = await cmsApi.post(LANDING_PAGE_CMS_DATA, data, config);
      
      // Check if the response contains maintenancePage data
      if (resp.data && resp.data.data && resp.data.data.maintenancePage && resp.data.data.maintenancePage.length > 0) {
        const maintenanceData = resp.data.data.maintenancePage[0];
        
        // Set the maintenance flag based on the CMS response
        setMaintenanceActive(maintenanceData.maintenanceFlag);
        setMaintenancePageData(maintenanceData.content.html);
        
        console.log("Maintenance flag from CMS:", maintenanceData.maintenanceFlag);
      } else {
        console.error("Maintenance data not found in the response");
      }
    } catch (error) {
      console.error("Error fetching maintenance data:", error);
      
      // If we get a 503 error from the CMS API, set maintenance mode to true
      // This handles the case when the interceptor might not be set up yet
      if (error?.response?.status === 503) {
        setMaintenanceActive(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Set up the centralized API error handling
  useEffect(() => {
    // Initialize the 503 error handling for all API instances
    setupMaintenanceHandling(setMaintenanceActive);
    
    // Fetch maintenance data on initial load
    fetchMaintenanceData();
  }, []);

  // The context value that will be supplied to any descendants of this provider
  const value = {
    maintenanceActive,
    maintenancePageData,
    isLoading,
    setMaintenanceActive,
    refreshMaintenanceStatus: fetchMaintenanceData
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceContext;